/**
 * Preload images into browser cache to prevent flickering
 */

// Import all site assets
import homeDefault from '../assets/site_assets/Top Bar/Top Bar 1.png';
import homeActive from '../assets/site_assets/Top Bar/Top Bar 1 Active.png';
import chaptersDefault from '../assets/site_assets/Top Bar/Top Bar 2.png';
import chaptersActive from '../assets/site_assets/Top Bar/Top Bar 2 Active.png';
import aboutDefault from '../assets/site_assets/Top Bar/Top Bar 3.png';
import aboutActive from '../assets/site_assets/Top Bar/Top Bar 3 Active.png';
import supportDefault from '../assets/site_assets/Top Bar/Top Bar 4.png';
import supportActive from '../assets/site_assets/Top Bar/Top Bar 4 Active.png';

import twitterIcon from '../assets/site_assets/1 Twitter.png';
import instagramIcon from '../assets/site_assets/2 Instagram.png';
import blueskyIcon from '../assets/site_assets/3 Bluesky.png';
import patreonIcon from '../assets/site_assets/4 Patreon.png';
import globalComixIcon from '../assets/site_assets/5 GlobalComix.png';

// Import all logos
import logoMainBW from '../assets/logos/Spirit Falls Logo MainBW.png';
import logoCreamsicle from '../assets/logos/Spirit Falls Logo Creamsicle.png';
import logoGreenGrey from '../assets/logos/Spirit Falls Logo GreenGrey.png';
import logoHalloween from '../assets/logos/Spirit Falls Logo Halloween.png';
import logoHoney from '../assets/logos/Spirit Falls Logo Honey.png';
import logoMonoPink from '../assets/logos/Spirit Falls Logo MonoPink.png';
import logoMushroom from '../assets/logos/Spirit Falls Logo Mushroom.png';
import logoOil from '../assets/logos/Spirit Falls Logo Oil.png';
import logoPastelBrooke from '../assets/logos/Spirit Falls Logo PastelBrooke.png';
import logoPastelLuna from '../assets/logos/Spirit Falls Logo PastelLuna.png';
import logoRedPurple from '../assets/logos/Spirit Falls Logo RedPurple.png';
import logoSpiritOcean from '../assets/logos/Spirit Falls Logo SpiritOcean.png';
import logoWanda from '../assets/logos/Spirit Falls Logo Wanda.png';
import logoMidnight from '../assets/logos/Spirit Falls Midgnight.png';

// All assets that should be preloaded
const assetsToPreload = [
  // Navigation buttons
  homeDefault,
  homeActive,
  chaptersDefault,
  chaptersActive,
  aboutDefault,
  aboutActive,
  supportDefault,
  supportActive,
  
  // Social icons
  twitterIcon,
  instagramIcon,
  blueskyIcon,
  patreonIcon,
  globalComixIcon,
  
  // All logos
  logoMainBW,
  logoCreamsicle,
  logoGreenGrey,
  logoHalloween,
  logoHoney,
  logoMonoPink,
  logoMushroom,
  logoOil,
  logoPastelBrooke,
  logoPastelLuna,
  logoRedPurple,
  logoSpiritOcean,
  logoWanda,
  logoMidnight
];

/**
 * Preload all UI assets into browser cache
 * Call this once when the app starts
 */
export function preloadUIAssets() {
  assetsToPreload.forEach(src => {
    const img = new Image();
    img.src = src;
  });
}

export default preloadUIAssets;

